import { WorkspaceFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetWorkspaceFilter = () => {
  return useSetFilter(WorkspaceFilterKey, 'workspaceFilter');
};
